import {
  Directive, OnInit, OnChanges, OnDestroy, SimpleChanges, Input, HostListener, Optional,
  EventEmitter, Output, ElementRef, ContentChildren, QueryList, NgZone, AfterViewInit
} from '@angular/core';
import { of, Subscription } from 'rxjs';
import {
  GridComponent, DataBindingDirective,
  SelectionDirective,
  CellClickEvent,
  DataStateChangeEvent, GridDataResult, PageChangeEvent, SortSettings,
} from '@progress/kendo-angular-grid';
import { process, GroupDescriptor, AggregateDescriptor, State, FilterDescriptor, SortDescriptor } from '@progress/kendo-data-query';
import {
  BindingData, BindingList, Change, ChangeType,
  FrameEventBus, UIState, Form, ViewModel, ComponentType
} from '@farris/devkit';
import { DialogService } from '@farris/ui-dialog';
import { RuntimeStateService } from '@farris/ui-common';
import { DateTimeHelperService } from '@farris/ui-common/date';
import { FarrisKendoGridFormatService } from '../format/index';
import { GridColumnAggregateDirective } from './grid-summary.directive';
import { MultiSelectGridUtility } from '../util/multi_select_grid_utility';
import { SelectedRowContext } from '../entity/index';

/*
 * Kendo Grid æ°æ®ç»å®æä»¤
 *
 * TODO:
 * 1ãæ´ä½å·å­å¨æ§è½é®é¢ï¼
 * 2ãéä¸­åå½åè¡æ²¡æåºåå¼ï¼
 */

@Directive({
  selector: '[farrisBindingPath]'
})
export class KendoGridBindingDirective extends DataBindingDirective implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  /**
   * æ¯å¦åè®¸ç¼è¾
   * é»è®¤å¯ç¼è¾  å ä¸ºææ¹éç¼è¾åè¡¨
   */
  @Input('farrisEditable')
  public editable: boolean;

  /**
   * ç¼è¾æ¶ç»å®çè¡¨å
   */
  @Input('farrisForm')
  public form: Form;

  /**
   * åç»å
   */
  @Input('groupField')
  public groupField: string;

  @Input('groupAggrFields')
  public groupAggrFields: string[];

  /* ç»å®grid option */
  @Input()
  public farrisBindingGridOption: any;

  /* å¼å®¹rowClass è¿æ²¡å é¤ */
  @Input()
  rowClassName: any;
  /* è¡æ ·å¼äºä»¶ */
  // @Input()
  // rowClassName: (context: any) => any;

  // tslint:disable-next-line:no-output-rename
  @Output('append-row') appendRow = new EventEmitter<any>();

  /* ç»å®æåºäºä»¶ */
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  /* è¡æ ·å¼äºä»¶ */
  @Output()
  rowClass: EventEmitter<any> = new EventEmitter<any>();


  get gridOption() {
    return this.grid['gridOption'];
  }
  get len() {
    return this.grid.columns.length;
  }

  dataItem: any;

  /* keydownç»å®äºä»¶å¯¹è±¡ */
  gridElement: any;
  gridKeydownEvent: any;

  /* cellclickäºä»¶å¯¹è±¡ */
  gridCellClickEvent: any;

  /* cellCloseäºä»¶å¯¹è±¡ */
  gridCellCloseEvent: any;


  cellClickEvent: CellClickEvent;

  hiddenColLen = 0;
  /**
   * TODO: ä»å®ä½è·åå¶é»è®¤å¼
   * å½åè¡ç´¢å¼å¼ï¼é»è®¤ç¬¬ä¸ä¸ª
   */
  rowIndex = 0;
  columnIndex = 0;
  sender: any;
  interVal: any;
  dataId: any;
  currentSkip = 0;
  private currentRowId: string;

  cellClickParam: CellClickEvent;
  /**
   * æ¯å¦å¯ç¨å¤éï¼é»è®¤æªå¯ç¨
   */
  private isMultipleSelectionMode = false;
  public get IsMultipleSelectionMode() {
    if (!this.grid) {
      return this.isMultipleSelectionMode;
    }

    if (this.grid.selectable) { // ä¼åå°è¯ä»this.grid.selectableè·å
      // tslint:disable-next-line: no-string-literal
      if (this.grid.selectable['mode'] === 'multiple') {
        this.isMultipleSelectionMode = true;
      } else {
        this.isMultipleSelectionMode = false;
      }
    } else {
      if (this.grid.selectableSettings && this.grid.selectableSettings.mode === 'multiple') {
        this.isMultipleSelectionMode = true;
      }
    }

    return this.isMultipleSelectionMode;
  }

  /**
   * ä¸ä¸ä¸ªéä¸­è¡ï¼é»è®¤ä¸å­å¨
   */
  public lastRowIndex = -1;

  /**
   * éä¸­è¡åæ¢äºä»¶
   */
  @Output() selectedRowChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * checkboxéæ©äºä»¶
   */
  @Output() selectedCheckboxChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * ç»å®åè¡¨(Gridå¯¹åºæ°æ®æº)
   */
  private get bindingList(): BindingList {
    // æ ¹å®ä½
    if (this.viewModel.bindingPath === '/' || !this.viewModel.bindingPath) {
      return this.bindingData.list;
    }
    // å­å®ä½
    let bindingPath = this.viewModel.bindingPath.substr(1);
    bindingPath = bindingPath[0].toLowerCase() + bindingPath.substring(1, bindingPath.length);
    const paths = bindingPath.split('/');

    const filteredPaths = paths.filter((part: string) => {
      return part !== '';
    });
    return this.bindingData.getValue(filteredPaths);
  }
  /**
   * è·ååé¡µä¿¡æ¯
   */
  private getPagingInfo() {
    const bindingPath = this.viewModel.bindingPath;
    const bindingData = this.viewModel.bindingData;
    let pagingInfo = bindingData.pagingInfo;
    if (bindingPath === '/') {
      return pagingInfo;
    } else {
      const bindingPaths = bindingPath.substr(1).split('/').filter(item => !!item && item.length > 0).map(item => {
        return item.substring(0, item.length - 1);
      });
      bindingPaths.forEach(path => {
        pagingInfo = pagingInfo && pagingInfo[path] || {};
      });
      return pagingInfo;
    }
  }

  @ContentChildren(GridColumnAggregateDirective) private aggrColumns: QueryList<GridColumnAggregateDirective>;
  private bindingChangeSubscription: Subscription;

  /**
   * æé å½æ°
   * @param  grid å®¿ä¸»Grid
   */
  constructor(
    public bindingData: BindingData,
    @Optional() public uiState: UIState,
    @Optional() public eventBus: FrameEventBus,
    @Optional() public viewModel: ViewModel,
    public grid: GridComponent,
    public selectionDir: SelectionDirective,
    public dialogSer: DialogService,
    private dateService: DateTimeHelperService,
    private kendogridFormatSer: FarrisKendoGridFormatService,
    private rts: RuntimeStateService,
    public ngZone: NgZone
  ) {
    super(grid);

    this.selectionDir.selectedKeys = [];
    this.viewModel.uiState.setPropertyValue('ids', this.selectionDir.selectedKeys);
    const appContext = this.viewModel.frameContext.getFormAppContext();
    if (appContext && appContext.hasOwnProperty('messagePipe')) {
      appContext.messagePipe.subscribe((message: any) => {
        this.grid.closeCell();
      });
    }
  }

  /**
   * æä»¤åå§åå
   */
  ngOnInit() {
    super.ngOnInit();

    // åå§åstateï¼åç»ä½¿ç¨ã
    this.initDataState();

    this.refreshView();
    if (this.viewModel && this.viewModel.frameContext && this.viewModel.frameContext.frameComponent) {
      this.viewModel.frameContext.frameComponent.componentType = ComponentType.kendoGridComponent;
    }
    // æ°æ®åå
    this.bindingChangeSubscription = this.bindingData.changes.subscribe((change: Change) => {
      this.refreshView(change);

      if (change.type === ChangeType.Load) {
        // loadæ¶ï¼å¨å¤éæ¨¡å¼ä¸ï¼éæ¸ç©ºéä¸­éå
        if (this.isMultipleSelectionMode) {
          const isMatch = this.checkIfChangeMatchBindingPath(change);
          if (isMatch) {
            // æ¸ç©ºå¤ééå
            this.selectionDir.selectedKeys = [];
            this.viewModel.uiState.setPropertyValue('ids', this.selectionDir.selectedKeys);
            this.ngZone.runOutsideAngular(() => {
              // æ¸²æåå§éä¸­è¡
              setTimeout(() => {
                const rowSelectedContext: SelectedRowContext = new SelectedRowContext();
                const isPageable = MultiSelectGridUtility.checkIfEnablePaging(this.grid);
                if (isPageable) {
                  this.rowIndex = this.grid.skip;
                } else {
                  this.rowIndex = 0;
                }
                rowSelectedContext.currentRowIndex = this.rowIndex;
                rowSelectedContext.lastRowIndex = this.lastRowIndex;
                this.handleSelectedRowChange(rowSelectedContext);
              }, 300);
            });
          }
        }
      }

      // TODO: ä½¿ç¨ç­ç¥æ¨¡å¼éæ
      // bindingData åæ­¥ SelectedKeys
      if (change.type === ChangeType.Remove) {
        this.syncDeletedKeys(change.value);
      }
      const isMatch = this.checkIfChangeMatchBindingPath(change);
      if (isMatch) {
        this.handleSelectedKeyChange(this.bindingList.currentId);
      }
      // æ¸²æå½åè¡
      if (isMatch && this.checkCurrentRowIdExists() && change.type === ChangeType.SelectionChanged && !this.dataId) {
        this.renderCurrentRow(this.bindingList.currentId);
      }
      // tslint:disable-next-line: max-line-length
      // FIXME:éè¦æéç½®é¡µç çæ¶æº
      /*if ((change.type === ChangeType.SelectionChanged || change.type === ChangeType.GlobalSelectionChanged) && this.currentRowId !== this.bindingList.currentId) {
          this.resetPageInfo();
      }*/
      // è§¦ååæ´æ£æµ
      if (change.type === ChangeType.Load || change.type === ChangeType.SelectionChanged
        || change.type === ChangeType.Append || change.type === ChangeType.Remove) {

        // è§¦ååæ´æ£æµ
        if (this.grid && this.grid['changeDetectorRef'] && this.grid['changeDetectorRef']['detectChanges']) {
          this.grid['changeDetectorRef']['detectChanges']();
        }
      }

    });

    if (this.editable === true && this.form === null) {
      throw Error('å¯ç¨ç¼è¾æ¶ï¼å¿é¡»æå®form');
    }
    if (!this.grid || !this.farrisBindingGridOption || !this.farrisBindingGridOption['fields']) {
      return;
    }

    const gridColumns = this.farrisBindingGridOption['fields'];
    const gridOption = this.farrisBindingGridOption;

    // å¤æ­åä¸­æ¯å¦å­å¨åºå®å
    gridOption.lockable = (columns: any[]) => {
      return columns.some(ele => {
        return ele.frozen;
      });
    };

    this.rowClass.emit(this.grid);
    // æ·»å åå±æ§æèæ¹æ³
    gridColumns.forEach((element: any) => {
      // èªå®ä¹è¶é¾
      if (element.linkedLabelEnabled && !element.linkEvent) {
        element.linkEvent = () => {
          return;
        };
      }

      // è¥æ²¡æèªå®ä¹æ ¼å¼åæ¹æ³  æ¯ä¸ªåå¯¹è±¡ç»å®æ ¼å¼åæ¹æ³
      if (!element.getColumnFormat) {
        element.getColumnFormat = (dataItem: any, column: any) => {
          return this.kendogridFormatSer.getColumnFormat(dataItem, column);
        };
      }

      // å¦ææ²¡æèªå®ä¹ç±»æ ·å¼ æ¯ä¸ªåç»å® æ ¼å¼åæ¹æ³
      if (!element.getClassName) {
        element.getClassName = (dataItem: any, column: any) => '';
      }

      // èªå®ä¹å¸®å©ååäºä»¶
      if (element.editor && element.editor.type === 'LookupEdit') {

        // å¸®å©åäºä»¶
        if (!element.dictPicking) {
          element.dictPicking = (param: any) => {
            return of(true);
          };
        }
        // å¸®å©åäºä»¶
        if (!element.dictPicked) {
          element.dictPicked = (param: any) => {
            // éæ°è¿å¥ç¼è¾
            this.cellClickHandler(this.cellClickParam);
            return of(true);
          };
        }
      }
    });
    // ç»å®gridOption
    this.bindingGridOption();

    // å¤éæ¨¡å¼ä¸ï¼è®¾ç½®åå§éä¸­è¡
    if (this.IsMultipleSelectionMode) {
      // TODO: ç§»é¤ setTimeout
      const self = this;
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          const rowSelectedContext: SelectedRowContext = new SelectedRowContext();
          rowSelectedContext.currentRowIndex = self.rowIndex;
          rowSelectedContext.lastRowIndex = self.lastRowIndex;
          self.handleSelectedRowChange(rowSelectedContext);
        }, 300);
      });
    }
  }


  ngAfterViewInit() {
    // this.gridElement = document.querySelector('.k-grid');
    // // ç»å®grid keydownå¯¹è±¡çæ¹æ³
    // this.ngZone.runOutsideAngular(() => {
    //   this.gridKeydownEvent = this.enterCell.bind(this);
    //   this.gridCellClickEvent = this.cellClickHandler.bind(this);
    //   this.gridCellCloseEvent = this.cellCloseHandler.bind(this);
    //   this.gridElement.addEventListener('keydown', this.gridKeydownEvent);
    //   this.gridElement.addEventListener('cellClick', this.gridCellClickEvent);
    //   this.gridElement.addEventListener('cellClose', this.gridCellCloseEvent);
    // });
  }
  /**
   * æ£æµchangeçè·¯å¾åBindingPathæ¯å¦å¹é
   */
  private checkIfChangeMatchBindingPath(change: Change): boolean {
    let isMatch = false;
    if (!change || !change.path) {
      return isMatch;
    }

    const changePathArray = change.path;
    if (!changePathArray) {
      return isMatch;
    }

    if (!(this.bindingData) && !(this.bindingData.bindingPath)) {
      return isMatch;
    }
    const bingdingPathArray = this.bindingData.bindingPath.split('/');
    if (bingdingPathArray.length <= 0) {
      return isMatch;
    }

    if (changePathArray.length === 0) { // ä¸»è¡¨
      if (this.bindingData.bindingPath === '/') {
        isMatch = true;
      }
    } else if (change.path.length === 1) {// ä¸»ä»è¡¨
      if (bingdingPathArray.length === 2 && bingdingPathArray[1] === change.path[0]) {
        isMatch = true;
      }
    } else if (change.path.length === 2) { // ä¸»ä»ä»è¡¨
      if (bingdingPathArray.length === 3 && bingdingPathArray[1] === change.path[0] && bingdingPathArray[2] === change.path[1]) {
        isMatch = true;
      }
    }

    return isMatch;
  }

  /**
   * å¤çéä¸­ä¸»é®åæ´
   */
  private handleSelectedKeyChange(currentId: any) {
    const selectedKeys = this.selectionDir.selectedKeys;
    if (!currentId) {

      // å¦æå½åè¡æ¶nullï¼ä½selectedKeyséæå¼ï¼æ¸ç©ºå¹¶åéä¸æ¬¡è¡åæ¢
      if (selectedKeys.length > 0) {
        const removedSelectedKeys = selectedKeys.splice(0, selectedKeys.length);
        if (removedSelectedKeys.indexOf(null) === -1) {
          this.emitSelectedRowChange({ currentRowId: null });
        }
      }
      return;
    }
    let oldCurrentRowId = null;
    if (this.IsMultipleSelectionMode) {
      oldCurrentRowId = this.currentRowId;
    } else {
      oldCurrentRowId = this.selectionDir.selectedKeys.length === 0
        ? null : this.selectionDir.selectedKeys[0];
    }

    // TODO:if (this.currentRowId !== currentId) {
    if (oldCurrentRowId !== currentId) {
      const selectedRowContext: any = {};
      selectedRowContext.currentRowId = currentId;
      this.currentRowId = currentId;
      this.emitSelectedRowChange(selectedRowContext);
    }
  }

  /**
   * åå°éä¸­è¡åæ¢äºä»¶
   * @description ç»ä¸åéæ¨¡å¼åå¤éæ¨¡å¼ä¸çè¡åæ¢äºä»¶
   */
  private emitSelectedRowChange(selectedRowContext: any) {
    if (!this.IsMultipleSelectionMode) { // ååå¼å®¹
      const currentId = selectedRowContext.currentRowId;
      this.selectionDir.selectedKeys = [currentId];
      this.selectionDir.selectedKeysChange.emit(this.selectionDir.selectedKeys);
    }

    this.selectedRowChange.emit(selectedRowContext);
  }

  private checkCurrentRowIdExists(): boolean {
    let isExist = false;

    if (this.bindingList && this.bindingList.currentId && this.bindingList.currentId.length > 0) {
      isExist = true;
    }

    return isExist;
  }

  /**
   * åæ­¥å·²å é¤é®å°éä¸­éå
   */
  private syncDeletedKeys(deletedValueCollection: any[]) {
    if (!deletedValueCollection) {
      return;
    }

    deletedValueCollection.forEach((id: string) => {
      const index = this.selectionDir.selectedKeys.indexOf(id);
      if (index > -1) {
        this.selectionDir.selectedKeys.splice(index, 1);

        // selectedKeysè¢«æ¸ç©ºçæ¶åï¼è§¦åä¸æ¬¡è¡åæ´
        if (this.selectionDir.selectedKeys.length === 0) {
          this.emitSelectedRowChange({ currentRowId: null });
        }
      }
    });
  }

  private renderCurrentRow(currentId: string) {
    if (!currentId || currentId === '') {// ä¸å­å¨å½åè¡
      return;
    }

    // TODO:ä½¿ç¨ç­ç¥æ¨¡å¼éæ
    if (this.IsMultipleSelectionMode) {
      return;
    }

    this.renderSelectionRow(this.bindingList.currentId, this.selectionDir.selectedKeys);
  }

  /**
   * æä»¤è¾å¥åæ´å¤ç
   */
  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.refreshView();
  }

  /**
   * æä»¤éæ¯ï¼æ³¨éè®¢é
   */
  ngOnDestroy() {
    if (this.bindingChangeSubscription) {
      this.bindingChangeSubscription.unsubscribe();
    }
  }

  private refreshView(change?: Change) {
    // this.bindData();
    this.refreshData(change);

    // å·æ°é¡µèåè®¡ä¿¡æ¯ãå®¢æ·ç«¯åè®¡ï¼ææ¶æ¾è¿éï¼æå¡ç«¯åè®¡æ¶æå¥½ä»è¿éç§»èµ°ãby justin
    this.refreshSummary();
  }

  /**
   * ç»å®dataå°å®¿ä¸»gridä¸
   * @deprecated
   */
  private bindData() {
    /*const data = this.bindingList.toJSON();
    let skip = 0;
    if (this.bindingList.pageIndex > 0) {
      skip = (this.bindingList.pageIndex - 1) * this.bindingList.pageSize;
    }
    this.updatePager(this.bindingList.pageSize, skip);
    const processed = process(data, Object.assign({}, this.state, { skip: 0 }));
    processed.total = this.bindingList.total;
    this.grid.data = processed;*/
  }

  private refreshData(change?: Change) {
    let skip = 0;
    const { pageIndex = 1, pageSize = 0 } = this.getPagingInfo() || {};
    if (pageIndex > 0) {
      skip = (pageIndex - 1) * pageSize;
    }
    this.updatePager(pageSize, skip);
    this.endCellEdit(change);
    this.data = this.bindingList.toJSON({ ignoreMultiLangInput: true });
  }
  /**
   * éåºç¼è¾ç¶æ
   * @param change åæ´
   */
  private endCellEdit(change?: Change) {
    const isEditing = this.grid.isEditing;
    if (change && change.type === ChangeType.Load && isEditing) {
      this.grid.cancelCell();
    }
  }
  private refreshSummary() {
    if (this.aggrColumns) {
      this.aggrColumns.forEach(aggrCol => {
        if (aggrCol.aggregate) {
          aggrCol.recalculateSummary(this.bindingList);
        }
      });
    }
  }

  @HostListener('pageChange', ['$event'])
  public onPageChange(event: PageChangeEvent) {
    const { skip = 0, take = 0 } = event || {};
    // this.bindingList.setPaginationInfo(skip, take);
    this.bindingData.setPagingInfo(skip, take, this.viewModel.bindingPath);
    // ç§»é¤éä¸­è¡æ ·å¼
    MultiSelectGridUtility.removeRowSelectedStyle(this.grid, this.rowIndex);
  }
  /**
   * éç½®gridåé¡µä¿¡æ¯
   */
  private resetPageInfo() {
    const { pageSize = 0 } = this.getPagingInfo() || {};
    this.bindingData.setPagingInfo(0, pageSize, this.viewModel.bindingPath);
  }
  private initDataState() {
    // const groups: GroupDescriptor[] = [];
    // if (this.groupField) {
    //   groups.push({field: this.groupField, aggregates: this.aggregates||[]});
    //   this.grid.group = groups;
    // }
    // this.state = Object.assign(this.state, {group: groups});

    const aggregatesDes: AggregateDescriptor[] = [];
    if (this.groupAggrFields) {
      for (const groupAggrField of this.groupAggrFields) {
        aggregatesDes.push({ field: groupAggrField, aggregate: 'sum' });
      }
    }

    const group: GroupDescriptor[] = [];
    if (this.groupField) {
      group.push({ field: this.groupField, aggregates: aggregatesDes });
    }
    this.group = group;

  }

  /*
   * @override
   * @param state State
   */
  onStateChange(state: DataStateChangeEvent) {
    // è¯´æï¼pageræ ¹æ®skipè®¡ç®å½åé¡µç ãkendo gridåé¨ä¼å¨filter stateååæ¶æskipåä¸º0ï¼éç½®å°ç¬¬ä¸é¡µï¼ã
    // å æ­¤éè¦éåonStateChangeæ¹æ³ï¼ä¿®æ­£skip
    if (state.skip !== this.currentSkip) {
      state.skip = this.currentSkip;
    }
    // ä½¿ç¨kendoé»è®¤çå¤çstateçé»è¾
    this.applyState(state);

    this.rebind();
  }

  // protected applyState({skip, take, sort, group, filter}: State): void {
  //   this.skip = skip;
  //   this.pageSize = take;
  //   this.sort = sort;
  //   this.group = group;
  //   this.filter = filter;
  // }

  /*
   * @override æå¡å¨ç«¯åé¡µåæ°ãprocessä½¿ç¨çstateä¸­skipåºä¸º0ï¼å¦åä¸æ¾ç¤ºæ°æ®
   * @param state State
   */
  protected process(state: State): GridDataResult {
    // if (this.editing) {
    //   state.sort = null;
    // } else {
    //   state.sort = this.originalSort;
    // }
    state.skip = 0;
    const { pageSize = 0, total: totalCount = 0 } = this.getPagingInfo() || {};
    // fixï¼ä¸å¯ç¨åé¡µæ¶ï¼take=0å¯¼è´processä¸è¿åæ°æ®
    if (state.take === 0) {
      state.take = this.bindingList.length;
    } else {
      state.take = pageSize;
    }
    // ç¼è¾æ¨¡å¼çå¤æ­ä¾æ®ä¸ºpageSizeå°äºç»å®æ°æ®çæ°éä¸å¯ç¨åé¡µ
    const isEditMode = state.take < this.bindingList.length;
    if (isEditMode) {
      state.take = this.bindingList.length;
    }
    const processed = super.process(state);
    // fix:æ°æ®ä»æ å°ææ¶åé¡µä¸å¯ç¨
    processed.total = Math.max(totalCount, this.bindingList.length);
    // åé¡µç¼è¾æ¨¡å¼ä¸æ°æ®æ»è®°å½æ°ä¸è½ç­äºçå®çæ°æ®æ°æ®ï¼å¦ååé¡µå·¥å·æ¡å°±ä¼èªå¨å¢å åé¡µé¡µç­¾
    if (isEditMode) {
      processed.total = totalCount || 1;
    }

    return processed;
  }

  /*
   * éä¸­è¡ä¸»é®ååå¤ç
   * @param event { SelectionEvent} éä¸­è¡ååå¤ç
   */
  @HostListener('selectedKeysChange', ['$event'])
  public selectedKeysChangeHandler(selectedKeys: string[]) {
    if (!(this.IsMultipleSelectionMode)) {// åéæ¨¡å¼ä¸
      // è®¾ç½®BindingDataä¸­çå½åè¡
      this.setSelectionIdToBindingData(selectedKeys[selectedKeys.length - 1]);
    }

    this.viewModel.uiState.setPropertyValue('ids', this.selectionDir.selectedKeys); // æ´æ°éå
  }

  /*
   * å¤çGridè¡åæ¢äºä»¶
   * @param event { SelectionEvent} è¡åæ¢äºä»¶å¯¹è±¡
   */
  @HostListener('selectionChange', ['$event'])
  public selectionChangeHandler(event: any) {
    if (this.IsMultipleSelectionMode) {
      this.handleSelectedCheckboxChange(this.grid.wrapper, event);
    }
  }

  /**
   * å¤çcheckboxéä¸­äºä»¶
   */
  private handleSelectedCheckboxChange(elementRef: ElementRef, event: any) {
    MultiSelectGridUtility.renderSelectedChangeCheckbox(elementRef, event);
    this.selectedCheckboxChange.emit(event);
  }

  /*
   * ååæ ¼ç¹å»å¤ç
   * @param event { CellClickEvent } ååæ ¼åå»äºä»¶å¯¹è±¡
   */
  @HostListener('cellClick', ['$event'])
  public cellClickHandler(event: CellClickEvent) {
    this.cellClickParam = event;
    this.cellClickEvent = event;
    this.rowIndex = event.rowIndex;
    this.columnIndex = event.columnIndex;
    this.sender = event.sender;

    // å¤éæ¨¡å¼ä¸ï¼ä¸ä¸åç»çæåµä¸ï¼æ£æµè¡åæ¢
    if (this.IsMultipleSelectionMode && !this.gridOption.groupable) {
      const currentRowIndex = event.rowIndex;
      if (currentRowIndex !== this.lastRowIndex) {
        const rowSelectedContext: SelectedRowContext = new SelectedRowContext();
        rowSelectedContext.currentRowIndex = currentRowIndex;
        rowSelectedContext.lastRowIndex = this.lastRowIndex;

        this.handleSelectedRowChange(rowSelectedContext);
      }
    }

    // è®¾ç½®å®ä½çå½åè¡
    this.dataId = this.getSelectedIdFromGrid(event.dataItem);
    this.setSelectionIdToBindingData(this.dataId);

    // è¥ç¶ææºä¸æ¯å¯ç¼è¾ç¶æ ä¸å¯ç¼è¾
    if (!this.isEditable()) {
      return;
    }



    // åæ¨¡æ¿ä¸å­å¨  ä¸å¯ç¼è¾
    if (!event.column.editTemplate) {
      return;
    }
    if (event.type === 'click' && !event.isEdited) {


      // å¦æå­å¨æ¾éç¶åµ  ç¡®å®æ­£ç¡®çcolumnIndex
      const originColums = this.getColumns(this.gridOption.fields);
      const columns: any[] = this.getColumns(originColums);
      const currentColumnIndex = columns.findIndex((col: any) => col.dataField === event.column.field);
      const hiddenColLen = columns.slice(0, currentColumnIndex + 1).filter(col => !col.visible).length;

      // èµå¼å¨å±è¡ç´¢å¼  åç´¢å¼
      this.rowIndex = event.rowIndex;
      this.columnIndex = event.columnIndex + hiddenColLen;
      this.hiddenColLen = hiddenColLen;
      this.sender = event.sender;

      this.setEditable(this.rowIndex, this.columnIndex);
    }
  }

  /**
   * å¤çéä¸­è¡åæ¢äºä»¶
   */
  private handleSelectedRowChange(rowSelectedContext: SelectedRowContext) {
    MultiSelectGridUtility.renderClickChangedRow(this.grid, rowSelectedContext);

    this.rowIndex = rowSelectedContext.currentRowIndex;
    this.lastRowIndex = rowSelectedContext.currentRowIndex;
    // æ´æ°å½åè¡
    const id = this.getPrimary(this.rowIndex);
    this.setSelectionIdToBindingData(id);
  }
  /**
   * è·åæå®è¡çä¸»é®
   * @param row è¡å·
   */
  private getPrimary(row: number) {
    let data: any = this.grid.data;
    if (data && !Array.isArray(data) && data.hasOwnProperty('data')) {
      data = data.data;
    }
    const { pageIndex = 1, pageSize = 0 } = this.getPagingInfo() || {};
    const skip = this.bindingList.skip;
    // ä¸åé¡µæèç¬¬ä¸é¡µæ¶åä¸éè¦ä¿®æ¹è¡å·
    const rowNumber = pageSize === 0 || pageIndex === 1 ? row : row - skip;
    if (data.length > rowNumber) {
      return data[rowNumber][this.bindingList.primaryKey];
    }
    return null;
  }

  /*
   * ååæ ¼ç»æç¼è¾å¤ç
   * @param event ååæ ¼ç»æç¼è¾äºä»¶å¯¹è±¡
   */
  @HostListener('cellClose', ['$event'])
  public cellCloseHandler(event: any): any {

    if (this.dialogSer.hasDialogOpened()) {
      event.preventDefault();
      return;
    }

    if (this.rts) {
      // å¸®å©ç»ä»¶ææ¬åååå»æ¥è¯¢
      if (this.rts.getFormState('lookup.pending')) {
        event.preventDefault();
        return;
      }

      // ç¹å»å¸®å©ç¡®å®å¯åæ¶æé®åä¸ç»æå½åååæ ¼ç¼è¾
      if (event.originalEvent) {
        if (this.rts.eventPath(event.originalEvent).find(n => n.tagName === 'FARRIS-DIALOG')) {
          event.preventDefault();
          return;
        }
      }
    }


    const { formGroup, column, dataItem, rowIndex } = event;
    const columns = this.getColumns(this.gridOption.fields);
    let currentCol = columns.find((element: any) => {
      return element.dataField === column.field;
    });
    const formControlValue = formGroup[currentCol.editor.binding.path].value;
    if (currentCol.getDynamicData) {
      // è¥æ­¤åæ¯å¨æååæ ¼å
      currentCol = currentCol.getDynamicData(dataItem, currentCol);
    }
    this.setValue(formControlValue, currentCol);
  }

  /*
     * åè½¦  åæ¢ååæ ¼
     * @param event é®çæä¸äºä»¶
     */
  @HostListener('keydown', ['$event'])
  enterCell(e: any) {
    // åè½¦é®
    if (!e.shiftKey && e.keyCode === 13) {
      // textarea enter å±è½æ¢è¡æä½
      e.preventDefault();
      if (!this.sender) {
        return;
      }
      // ç±äºkeydown äºä»¶ä¼åæ§è¡ï¼æä»¥è¿éåè¦æ§è¡blur äºä»¶ï¼
      e.target.blur();
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          if (this.rts && this.rts.getFormState('lookup.pending')) {
            e.preventDefault();
            return;
          }
          this.enterNextCell();
        }, 201);
      });
    }
  }

  /*
     * ç»å®grid option
     * @param dataItem è¡æ°æ®
     */
  private bindingGridOption() {
    if (!this.farrisBindingGridOption) {
      return;
    }
    Object.defineProperty(this.grid, 'gridOption', { value: this.farrisBindingGridOption });
  }

  /*
   * æ´æ°Gridåé¡µç¶æ
   * @param take
   * @param skip
   */
  private updatePager(take: number, skip: number) {
    if (take === 0) {
      this.currentSkip = 0;
      this.pageSize = 0;
      this.skip = 0;
      this.grid.pageable = false;
    } else {
      this.currentSkip = skip;
      this.skip = skip;
      this.pageSize = take;
      this.grid.pageable = {
        buttonCount: 10,
        info: true,
        type: 'numeric',
        pageSizes: false,
        previousNext: true
      };
    }
  }

  /*
   * è®¾ç½®ååæ ¼å¯ç¼è¾æ§
   * @param dataItem è¡æ°æ®
   * @param column åå¯¹è±¡
   * @param rowIndex è¡ç´¢å¼
   * @param columnIndex åç´¢å¼
   * @param sender gridå®ä¾
   */
  setEditable(rowNumber: number, columnNumber: number) {
    const data = this.grid.data['data'];
    const { pageIndex = 1, pageSize = 0 } = this.getPagingInfo() || {};
    const skip = this.bindingList.skip;
    // ä¸åé¡µæèç¬¬ä¸é¡µæ¶åä¸éè¦ä¿®æ¹è¡å·
    const dataRowNumber = pageSize === 0 || pageIndex === 1 ? rowNumber : rowNumber - skip;
    let item = data[dataRowNumber];
    if (this.gridOption.groupable) {
      item = this.getGroupItem(data, dataRowNumber);
    }
    const originColums = this.getColumns(this.gridOption.fields);
    const columns = this.getColumns(originColums);
    /* åå¦åçé¡ºåºæ¹å æ¯å¦å­å¨åºå®å  é£ä¹åºè¯¥è·åçæ­£çåå¯¹è±¡ */
    // let col = columns[columnNumber];

    let tempIndex = columnNumber;
    // å½ååç´¢å¼ä¸ä¸º0
    if (this.grid['gridOption'].showLineNumber) {
      tempIndex = tempIndex - 1;
    }
    if (this.grid.selectable && this.grid.selectable['mode'] === 'multiple') {
      tempIndex = tempIndex - 1;
    }
    const col = columns[tempIndex];

    const params = {
      dataItem: item,
      column: col,
      rowIndex: rowNumber,
      columnIndex: tempIndex,
    };

    // æ§å¶ååæ ¼çå¯ç¼è¾æ§
    if (col && !col.editable) {
      col.editable = (param: object) => true;
    }
    if (col && this.notReadOnly(col, params)) {
      // è®¾ç½®å½åè¡
      this.dataId = this.getSelectedIdFromGrid(item);
      this.setSelectionIdToBindingData(this.dataId);
      // const value = this.getValue(item, col.dataField);
      // this.setValue(value, col);
      this.sender.editCell(rowNumber, columnNumber - this.hiddenColLen, this.viewModel.form);
    }

  }
  /*
  è·åæ´æ° rowIndex columnIndex
   */
  updateIndex(rowNumber: number, columnIndex: number) {
    const newColumnIndex = (columnIndex + 1) % this.len;
    if (!newColumnIndex) {
      const dataLen = this.bindingList.toJSON().length;
      const newRowIndex = (rowNumber + 1) % dataLen;
      return { rowIndex: newRowIndex, columnIndex: newColumnIndex };
    }
    return {
      rowIndex: rowNumber,
      columnIndex: newColumnIndex
    };
  }

  /* æ¯å¦åªè¯» */
  notReadOnly(column: any, param: any) {
    if (!column) {
      return false;
    }
    return column.editable(param) && !column.editor.readonly;
  }

  /*
     * ç»åè¡¨èµå¼ æç»formcontrolèµå¼
      */
  setValue(value: any, column: any) {
    const currentColumnType = column.dataType;
    // åæ¶å¤æ­gridOptionçåå¯¹è±¡
    const bindingData = this.viewModel.bindingData;
    const fieldPaths = this.getFieldPaths(bindingData.bindingPath, column.dataField);
    // å­å¨è¡ç¼è¾å¨
    if (currentColumnType === 'date') {
      let dateStr = this.dateService.formatTo(value, 'yyyy-MM-dd HH:mm:ss');
      if (!dateStr) {
        dateStr = '';
      }
      this.viewModel.bindingData.setValue(fieldPaths, dateStr, true, true);
    } else {
      this.viewModel.bindingData.setValue(fieldPaths, value, true, true);
    }
  }

  /* åç»æ¶ è·åç¹å»è¡æ°æ® */
  getGroupItem(data: any[], rowNumber: number) {
    let index = rowNumber;
    for (const i in data) {
      if (index < data[i].items.length) {
        return data[i].items[index];
      } else {
        index = index - data[i].items.length;
      }
    }
  }

  /*
   * è·å ååæ ¼å¼  ä¸»ä»è¡¨æ¯æ
   * @param dataItem è¡æ°æ®
   * @param field å­æ®µ
   */
  getValue(dataItem: any, field: string) {
    const index = field.indexOf('.');
    if (index < 0) {
      return dataItem[field];
    }
    const fields = field.split('.');
    // fieldå­ç¬¦ä¸²ç»å
    return fields.reduce((result: any, next: any) => {
      return result[next];
    }, dataItem);
  }

  /*
  * è·å bindingData è·¯å¾
  * @param bindingPath å½åç»å®çå­æ®µè·¯å¾
  * @param fieldName å­æ®µ
  */
  private getFieldPaths(bindingPath: string, field: string): string[] {
    let fieldPath = '';
    if (bindingPath.length > 1) {
      fieldPath = bindingPath.substr(1).replace(/\//g, '.') + '.' + field;
    } else {
      fieldPath = field;
    }
    return fieldPath.split('.');
  }

  /**
   * åè½¦è¿å¥ä¸ä¸ä¸ªååæ ¼
   */
  enterNextCell() {
    const index = this.updateIndex(this.rowIndex, this.columnIndex);
    if (!index.columnIndex && !index.rowIndex) {
      const len = this.bindingList.toJSON().length;
      // å¦æå­å¨æ·»å æ°æ®çAPI
      this.appendRow.emit();
      if (this.appendRow.observers && this.appendRow.observers.length) {
        this.interVal = setInterval(() => {
          if (this.bindingList.toJSON().length - 1 === len) {
            this.setEditable(this.bindingList.toJSON().length - 1, 0);
            this.rowIndex = this.bindingList.toJSON().length - 1;
            this.columnIndex = 0;
            clearInterval(this.interVal);
          }
        }, 0);
        return;
      }
    }

    this.setEditable(index.rowIndex, index.columnIndex);
    this.rowIndex = index.rowIndex;
    this.columnIndex = index.columnIndex;
  }

  /* è·åçæ­£çåå¯¹è±¡ */
  getColumns(columns: any) {
    // å¤æ­æ¯å¦å­å¨åºå®å
    const hasLocked = columns.some((ele: any) => {
      return ele.frozen;
    });
    if (hasLocked) {
      const lockedColumns = columns.filter((ele: any) => {
        return ele.frozen;
      });
      const notLockedColumns = columns.filter((ele: any) => {
        return !ele.frozen;
      });
      return [...lockedColumns, ...notLockedColumns];
    }
    return columns;
  }

  /*
   * æ¸²ææå®è¡ä¸ºéä¸­è¡ï¼å°æå®è¡çkeyæ·»å å°éä¸­è¡éåä¸­
   */
  private renderSelectionRow(key: string, selectedKeys: any[]) {
    if (!key || key === '') {
      return;
    }

    // TODO:ä½¿ç¨ç­ç¥æ¨¡å¼éæ
    if (this.IsMultipleSelectionMode) {
      const index = selectedKeys.indexOf(key);
      if (index >= 0) {
        return;
      }

      selectedKeys.push(key);
    } else {
      if (selectedKeys.length === 1 && selectedKeys[0] === key) {
        return;
      }

      selectedKeys.splice(0, selectedKeys.length);
      selectedKeys.push(key);
    }

    this.selectionDir.selectedKeysChange.emit(selectedKeys); // æå¨è§¦åselectedKeysChangeäºä»¶
  }

  /*
   * è·åGridä¸çå½åè¡åç 
   * @param dataItem è¡æ°æ®
   */
  private getSelectedIdFromGrid(dataItem: any) {
    const primaryKey = this.bindingList.primaryKey;
    return dataItem[primaryKey];
  }

  /*
   * è®¾ç½®BindingListçå½åè¡
   * @param id å½åè¡åç 
   */
  private setSelectionIdToBindingData(id: string): void {
    this.bindingList.setCurrentId(id, true);
  }

  /*
  *åè¡¨æ´ä½æ¯å¦å¯ç¼è¾
   */
  isEditable() {
    if (this.editable === undefined) {
      if (!this.viewModel.stateMachine) {
        // ç¶ææºä¸å­å¨çæ¶å
        return false;
      }
      // ç¶ææºå­å¨çæ¶å
      return this.viewModel.stateMachine['editable'];
    }
    // èªå®ä¹èµå¼
    return this.editable;
  }
  /*  */
  isDataChanged() {
    let hasUnsavedData = false;
    const entityArray = this.viewModel.frameContext.repository.entityCollection.toArray();
    for (const entity of entityArray) {
      if (entity.changes.length > 0) {
        hasUnsavedData = true;
        break;
      }
    }
    return hasUnsavedData;
  }
}
